import { FloorPlannerController } from "./scripts/FloorPlannerController.js";
import {
  EVENT_LOADED,
  EVENT_ROOM_DIMENSION_CLICKED,
  EVENT_NOTHING_SELECTED,
  EVENT_CORNER_CLICKED,
  EVENT_WALL_CLICKED,
  EVENT_ROOM_CLICKED,
  EVENT_WALL_DIMENSION_CLICKED,
  EVENT_ICONS_CLICKED,
  EVENT_LABEL_CLICKED,
  EVENT_ARROW_CLICKED,
  EVENT_MODE_RESET,
  EVENT_ROOM_METADATA_CHANGED,
} from "./scripts/core/events.js";
import {
  Configuration,
  configDimUnit,
  viewBounds,
  gridSize,
  fontSize,
} from "./scripts/core/configuration.js";
import { dimFeetAndInch } from "./scripts/core/constants.js";
import * as icons_json from "./icons.json";
import jspdf from "jspdf";
import autoTable from "jspdf-autotable";
import * as config_json from "./config.json";

import { floorplannerModes } from "./scripts/view/Viewer.js";

let pdfWidth = 210; // mm
let pdfHeight = 297; // mm
function getPdfPageSize(orientation) {
  if (orientation == "l") {
    return [pdfHeight, pdfWidth];
  }

  return [pdfWidth, pdfHeight];
}

let fontSizeList = [15, 18, 20, 22, 24, 28, 32, 36, 42, 44, 48, 50];

let gridSizeList = [
  { name: "2 Ft", value: 0.04 },
  { name: "4 Ft", value: 0.08 },
  { name: "6 Ft", value: 0.12 },
  { name: "8 Ft", value: 0.16 },
  { name: "10 Ft", value: 0.2 },
];

let fontColorList = [
  {
    name: "Black",
    color: "#000000",
  },
  {
    name: "Red",
    color: "#e74c3c",
  },
  {
    name: "Green",
    color: "#008000",
  },
];

let ConfigSettings = config_json[process.env.NODE_ENV];

let baseUrl = ConfigSettings.ADMIN_URL;

let logoUrl = "./assets/logo.png";

const compressPDF = true;

let jsPdf = new jspdf("p", "mm", getPdfPageSize("p"), compressPDF);
let pageWidth = jsPdf.internal.pageSize.getWidth();
let pageHeight = jsPdf.internal.pageSize.getHeight();

let floorPlannerController = null;
let floorPlannerViewer = null;
let configurationHelper = null;
let floorplanningHelper = null;

let areaDetailLists = [];
let areaTypeLists = [];
let saveFilename = "design";

let selectedRoom = null;
let selectedLabel = null;
let selectedIcon = null;

let areaSettingsTemplate = null;
let iconSettingsTemplate = null;
let iconsListTemplate = null;
let PresetTemplate = null;
let labelSettingsTemplate = null;
let SettingsTemplateView = null;

let alertAnimationName = "";

let roomSettingPanel = document.getElementById("roomSettingPanel");
let labelSettingPanel = document.getElementById("labelSettingPanel");
let iconSettingPanel = document.getElementById("iconSettingPanel");
let iconListPanel = document.getElementById("iconListPanel");
let SettingPanel = document.getElementById("SettingPanel");

Handlebars.registerHelper("ifeq", function (a, b, options) {
  if (a == b) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper("inc", function (value, options) {
  return parseInt(value) + 1;
});

/* Predefined Floorplanner Settings Options */
let options = {
  viewer2d: {
    id: "floorPlannerViewer",
    viewer2dOptions: {
      "corner-radius": 7,
      "boundary-point-radius": 3.0,
      "boundary-line-thickness": 2.0,
      "boundary-point-color": "#030303",
      "boundary-line-color": "#090909",
      pannable: true,
      zoomable: true,
      scale: false,
      rotate: true,
      translate: true,
      dimlinecolor: "#3E0000",
      dimarrowcolor: "#FF0000",
      dimtextcolor: "#000000",
      pixiAppOptions: {
        resolution: 1,
      },
      pixiViewportOptions: {
        passiveWheel: false,
      },
    },
  },
  resize: true,
};

/* Predefined Icons Loaded to Icons List UI */
function loadIconList() {
  if (!iconsListTemplate) {
    iconsListTemplate = Handlebars.compile(
      document.getElementById("iconsListTemplate").innerHTML,
    );
  }

  iconListPanel.innerHTML = iconsListTemplate(icons_json);
  iconListPanel.classList.add("show");
}

function loadAreaData() {
  fetch(baseUrl + "fetch-area-details")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      areaDetailLists = data.data;
      areaTypeLists = data.type;
    })
    .catch((error) => {
      console.log(error);
    });
}

/* Predefined Area Loaded to Json */
loadAreaData();

function switchViewerToDraw() {
  floorPlannerController.setViewerModeToDraw();
}

function switchViewerToMove() {
  floorPlannerController.setViewerModeToMove();
}

function switchViewerToTransform() {
  floorPlannerController.switchViewerToTransform();
}

/* Draw Arrow to Canvas Scene */
function drawArrow() {
  floorPlannerController.setViewerModeToDraw(true);
}
/* Unversal Font Size Change */
function setFontSize(size) {
  floorPlannerController.setFontSize(size);
}
/* Load Json to Canvas Scene */
function loadDesign(filedata) {
  let reader = new FileReader();
  reader.onload = function (event) {
    let data = event.target.result;
    floorPlannerController.model.loadSerialized(data);
  };
  reader.readAsText(filedata);
}
/* Add Icon to Canvas Scene */
function addIcon(url, name) {
  let icon = {
    url,
    name,
  };
  const img = new Image();
  img.src = icon.url;
  img.onload = function () {
    icon.width = img.naturalWidth;
    icon.height = img.naturalHeight;
    floorPlannerController.insertIcons(icon);
    $("#navbarSupportedContent ul li").removeClass("active");
    $(".top-side-setting-panel").removeClass("show");
  };
}
/* Add Label to Canvas Scene */
function addLabel() {
  let label = { text: "Label Text" };
  floorPlannerController.insertLabels(label);
  $("#navbarSupportedContent ul li").removeClass("active");
}

/* Settings Popup Configure Function */
function settingsOpen() {
  let size = Configuration.getNumericValue(gridSize);
  let fontsize = Configuration.getNumericValue(fontSize);
  let data = {
    size: size,
    gridSizeList: gridSizeList,
    fontsizelist: fontSizeList,
    fontsize: fontsize,
  };
  if (!SettingsTemplateView) {
    SettingsTemplateView = Handlebars.compile(
      document.getElementById("SettingsTemplate").innerHTML,
    );
  }
  SettingPanel.innerHTML = SettingsTemplateView(data);
  SettingPanel.classList.add("show");

  $("input[name=size][value='" + data.size + "']").prop("checked", true);
  // $("input[name=size][value='" + data.size + "']"). prop('checked', true)
  $(document).find("#fontSizeInputUniversal").val(data.fontsize);
  // $(document).find('#fontSizeInput').val(data.size);
}

/* Save Design Function */
function saveDesign() {
  let data = floorPlannerController.model.exportSerialized();
  let a = window.document.createElement("a");
  let blob = new Blob([data], { type: "text" });
  a.href = window.URL.createObjectURL(blob);
  a.download = saveFilename + ".json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  $("#navbarSupportedContent ul li").removeClass("active");
}

function saveScreenShot() {
  let data = floorPlannerController.getImageData();
  console.log(data.image);
  var a = document.createElement("a"); //Create <a>
  a.href = data.image; //Image Base64 Goes here
  a.download = "ScreenShot.png"; //File name Here
  a.click(); //Downloaded file
}

/* Export Pdf Generate Function */
function exportPdf() {
  const rooms = floorPlannerController.model.floorplan.getRoomDataJson();
  const data = floorPlannerController.getImageData();

  const img = new Image();
  img.src = data.image;

  img.onload = async function () {
    const imgWidth = img.naturalWidth;
    const imgHeight = img.naturalHeight;

    // Load logo first (async)
    const logoImg = new Image();
    logoImg.src = logoUrl;

    logoImg.onload = function () {
      // HEADER HEIGHT
      const headerH = 20;

      // Get page sizes
      const pageW = jsPdf.internal.pageSize.getWidth();
      const pageH = jsPdf.internal.pageSize.getHeight();

      // ---- HEADER FUNCTION ----
      function drawHeader() {
        // Draw logo
        jsPdf.addImage({
          imageData: logoImg,
          x: 5,
          y: 3,
        });
      }

      // ---- PAGE 1 ----
      drawHeader();

      // Margin under header
      const margin = 20;
      const usableTop = headerH + 4;

      const maxW = pageW - margin * 2;
      const maxH = pageH - usableTop - margin;

      const imgRatio = imgWidth / imgHeight;
      const pageRatio = maxW / maxH;

      let drawW, drawH;

      if (imgRatio > pageRatio) {
        drawW = maxW;
        drawH = maxW / imgRatio;
      } else {
        drawH = maxH;
        drawW = maxH * imgRatio;
      }

      // Center the image inside remaining space
      const left = (pageW - drawW) / 2;
      const top = usableTop + (maxH - drawH) / 2;

      jsPdf.addImage(data.image, "PNG", left, top, drawW, drawH);

      // ---- PAGE 2 ----
      jsPdf.addPage("p", "mm", getPdfPageSize("p"));
      // drawHeader();

      jsPdf.setFontSize(14);
      jsPdf.text("Area Calculations Summary", 15, headerH + 10);

      const body = [
        ...rooms.rooms,
        [
          {
            content: `Net LIVABLE Area : ${rooms.total}`,
            colSpan: 5,
            styles: {
              fillColor: "#10ac84",
              textColor: "#FFFFFF",
              halign: "right",
              valign: "middle",
              fontSize: 12,
            },
          },
        ],
      ];

      autoTable(jsPdf, {
        head: [
          ["Code", "Name", "Factor", "Net Size (Sq.ft)", "Net Total (Sq.ft)"],
        ],
        headStyles: { fillColor: "#10ac84" },
        body: body,
        rowPageBreak: "avoid",
        styles: {
          fontSize: 10,
          lineWidth: 1,
          lineColor: "#10ac84",
          valign: "middle",
          cellPadding: 2,
        },
        columnStyles: {
          2: { halign: "center" },
          3: { halign: "right" },
          4: { halign: "right" },
        },
        startY: headerH + 20,
      });

      jsPdf.save(saveFilename + ".pdf");

      // Reset PDF object (important)
      jsPdf = jspdf("p", "mm", getPdfPageSize("p"), compressPDF);
      $("#navbarSupportedContent ul li").removeClass("active");
    };
  };
}

Configuration.setValue(viewBounds, 10000); //In CMS

floorPlannerController = new FloorPlannerController(options);
Configuration.setValue(configDimUnit, dimFeetAndInch);

configurationHelper = floorPlannerController.configurationHelper;
floorplanningHelper = floorPlannerController.floorplanningHelper;
floorPlannerViewer = floorPlannerController.floorplanner;

floorPlannerController.model.addEventListener(EVENT_LOADED, function () {
  console.log("LOAD SERIALIZED JSON ::: ");
});
floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_NOTHING_SELECTED,
  function () {
    $(".right-side-setting-panel").removeClass("show");
    $(".top-side-setting-panel").removeClass("show");
    if (
      floorPlannerController.getCurrentFloorplanMode() ===
      floorplannerModes.EDIT_ISLANDS
    ) {
      if (selectedRoom) {
        selectedRoom = null;
      }
      switchViewerToMove();
      $("#navbarSupportedContent ul li").removeClass("active");
    }
  },
);
floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_CORNER_CLICKED,
  function (evt) {},
);
floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_WALL_CLICKED,
  function (evt) {},
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_WALL_DIMENSION_CLICKED,
  function (evt) {},
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_ROOM_DIMENSION_CLICKED,
  function (evt) {},
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_ARROW_CLICKED,
  function (evt) {
    $("#navbarSupportedContent ul li").removeClass("active");
  },
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_ICONS_CLICKED,
  function (evt) {
    selectedIcon = evt.item;
    let data = {
      rotation: evt.item.rotation,
      scale: evt.item.scale,
    };

    if (!iconSettingsTemplate) {
      iconSettingsTemplate = Handlebars.compile(
        document.getElementById("iconSettingsTemplate").innerHTML,
      );
    }
    iconSettingPanel.innerHTML = iconSettingsTemplate(data);
    iconSettingPanel.classList.add("show");
  },
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_LABEL_CLICKED,
  function (evt) {
    selectedLabel = evt.item;
    let data = {
      rotation: evt.item.label.rotation,
      text: evt.item.label.text,
      fontsize: evt.item.label.style.fontSize,
      fontcolor: evt.item.label.style.fill,
      fontsizelist: fontSizeList,
      fontcolorlist: fontColorList,
    };
    if (!labelSettingsTemplate) {
      labelSettingsTemplate = Handlebars.compile(
        document.getElementById("labelSettingsTemplate").innerHTML,
      );
    }
    labelSettingPanel.innerHTML = labelSettingsTemplate(data);
    labelSettingPanel.classList.add("show");

    $("input[name=color][value='" + data.fontcolor + "']").prop(
      "checked",
      true,
    );
    $(document).find("#fontSizeInput").val(data.fontsize);
  },
);

floorPlannerController.floorplanner.addFloorplanListener(
  EVENT_ROOM_CLICKED,
  function (evt) {
    // console.log('RoomClick',evt.item);
    if (
      floorPlannerController.getCurrentFloorplanMode() ===
      floorplannerModes.EDIT_ISLANDS
    ) {
      $("#navbarSupportedContent ul li").removeClass("active");
      $("#TransformModel").addClass("active");
      return;
    }
    loadAreaData();
    selectedRoom = evt.item;
    let data = {
      code: selectedRoom.code,
      description: selectedRoom.name,
      factor: selectedRoom.factor,
      type: selectedRoom.roomType,
      list: areaDetailLists,
      typelist: areaTypeLists,
    };
    let areadetail = areaDetailLists.find((value) => value.code === data.code);
    data.id = areadetail ? areadetail.id : 0;
    if (!areaSettingsTemplate) {
      areaSettingsTemplate = Handlebars.compile(
        document.getElementById("areaSettingsTemplate").innerHTML,
      );
    }
    roomSettingPanel.innerHTML = areaSettingsTemplate(data);
    setTimeout(function () {
      roomSettingPanel.classList.add("show");
    }, 100);

    if (selectedRoom) {
      $(".presetarealistul li").removeClass("active");
      $(document)
        .find("#areaCode" + data.id)
        .addClass("active");
      $(document).find("#typeText").val(data.type);
      $("#navbarSupportedContent ul li").removeClass("active");
    }
  },
);

function hideErrorMsg(id) {
  $("#" + id + "_error").removeClass("show");
  $("#" + id + "_text").removeClass("error");
}

function showErrorMsg(msg, id) {
  $("#" + id + "_error").html(msg);
  $("#" + id + "_text").addClass("error");
  $("#" + id + "_error").addClass("show");
}

$("#dummyClick").click(function (e) {
  roomSettingPanel.classList.add("show");
});

floorPlannerController.model.addEventListener(EVENT_MODE_RESET, function (evt) {
  $("#navbarSupportedContent ul li").removeClass("active");
});

// floorPlannerController.model.loadSerialized(designJson);

/* Load Button Action Event */
var importCabiPlanDesignFile = document.getElementById("importDesignFile");

importCabiPlanDesignFile.addEventListener(
  "change",
  function (event) {
    var files = importCabiPlanDesignFile.files;
    loadDesign(files[0]);
    importCabiPlanDesignFile.value = "";
    $("#navbarSupportedContent ul li").removeClass("active");
  },
  true,
);

/* Validation Slider as Min and Max Value to Be exit check for corresponding textbox  */
function SliderValidation(value, id, type) {
  if (!isNaN(value)) {
    if (id != "") {
      let min = parseFloat($("#" + id).attr("min"));
      let max = parseFloat($("#" + id).attr("max"));
      if (parseFloat(value) >= min && parseFloat(value) <= max) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return false;
  }
}

$(document).on("input", "#SearchInput", function (e) {
  let value = $(this).val();
  value = value.toLowerCase();
  let filteredareaDetails;
  fetch(baseUrl + "search-area-details", {
    method: "POST",
    body: JSON.stringify({ keyword: value }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    cache: "default",
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      filteredareaDetails = data.data;
      if (!PresetTemplate) {
        PresetTemplate = Handlebars.compile(
          document.getElementById("PresetTemplate").innerHTML,
        );
      }
      let listData = PresetTemplate({ list: filteredareaDetails });
      $(".presetarealistul").html(listData);
    })
    .catch((error) => {
      console.log(error);
    });
});

/* Icons Scale Text Box Type Event  */
$(document).on("input change", ".slider-text", function () {
  let type = $(this).data("type");
  let id = $(this).data("id");
  let value = $(this).val();
  if (value != "") {
    let checkValidation = SliderValidation(value, id, type);
    if (checkValidation) {
      if (id != "") {
        $("#" + id).val(value);
        hideErrorMsg(id);
      }

      switch (type) {
        case "iconScale":
          floorplanningHelper.iconScale = parseFloat(value);
          break;
        case "iconRotate":
          floorplanningHelper.iconRotation = parseFloat(value);
          break;
      }
    } else {
      if (id != "") {
        showErrorMsg("your value is out of range", id);
      }
    }
  } else {
    showErrorMsg("please enter value", id);
  }
});

/* Top Menu Button Action Event as Draw, Add Icon, Add Text, 
   Mark Arrow, Reset, Save, Load, Export PDF  */

$(".actionEvent").click(function (e) {
  $("#navbarSupportedContent ul li").removeClass("active");
  $(this).parent("li").addClass("active");
  let type = $(this).data("type");
  switch (type) {
    case "draw":
      switchViewerToDraw();
      break;
    case "move":
      switchViewerToTransform();
      break;
    case "arrow":
      drawArrow();
      break;
    case "addText":
      addLabel();
      break;
    case "exportPdf":
      Swal.fire({
        title: "Please enter a filename for your PDF",
        input: "text",
        inputLabel: "",
        inputPlaceholder: "my PDF",
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonColor: "#fff",
        confirmButtonText: "Save",
        cancelButtonText: "Close",
        showClass: {
          popup: "animate__animated " + alertAnimationName,
        },
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Please Enter Filename");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value != "") {
            saveFilename = result.value;
            exportPdf();
          }
        }
      });

      break;
    case "reset":
      Swal.fire({
        title: "",
        text: "This will clear everything in your page & load a blank canvas. Do you want to continue?",
        showCancelButton: true,
        confirmButtonColor: "#10ac84",
        cancelButtonColor: "#fff",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showClass: {
          popup: "animate__animated " + alertAnimationName,
        },
      }).then((result) => {
        if (result.isConfirmed) {
          floorPlannerController.model.reset();
          $(".right-side-setting-panel").removeClass("show");
          $(".top-side-setting-panel").removeClass("show");
        }
      });
      break;
    case "save":
      Swal.fire({
        title: "Download file as",
        input: "text",
        inputLabel: "",
        inputPlaceholder: "my file name",
        allowOutsideClick: false,
        allowOutsideClick: true,
        showCancelButton: true,
        cancelButtonColor: "#fff",
        confirmButtonText: "Save",
        cancelButtonText: "Close",
        showClass: {
          popup: "animate__animated " + alertAnimationName,
        },
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Please Enter Filename");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          if (result.value != "") {
            saveFilename = result.value;
            saveDesign();
          }
        }
      });
      break;
    case "load":
      importCabiPlanDesignFile.click();
      break;
    case "addIcon":
      loadIconList();
      break;
    case "settings":
      settingsOpen();
      break;
  }
  e.preventDefault();
});

/* Define Area Preset List click Event Action  */
$(document).on("click", ".presetarealistul li a", function (e) {
  let id = $(this).data("id");
  $(".presetarealistul li").removeClass("active");
  $(this).parent("li").addClass("active");

  let areadetail = areaDetailLists.find((value) => value.id === id);
  $(document)
    .find("#areaTitle")
    .html(areadetail.code + " - " + areadetail.description);
  $(document).find("#codeText").val(areadetail.code);
  $(document).find("#descriptionText").val(areadetail.description);
  $(document).find("#factorText").val(areadetail.factor);
  $(document).find("#typeText").val(areadetail.type);
  $(document).find("#updateAreaId").val(areadetail.id);

  e.preventDefault();
});

/* Delete Action on Custom Label,Icons to Canvas  */
$(document).on("click", ".deletebtn", function (e) {
  Swal.fire({
    title: "Are you Sure ?",
    text: "Do you really want to remove it?",
    showCancelButton: true,
    confirmButtonColor: "#10ac84",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showClass: {
      popup: "animate__animated " + alertAnimationName,
    },
  }).then((result) => {
    if (result.isConfirmed) {
      floorplanningHelper.deleteCurrentItem();
      $(".right-side-setting-panel").removeClass("show");
      $(".top-side-setting-panel").removeClass("show");
    }
  });
  e.preventDefault();
});

/* Close Button Action Event  */
$(document).on("click", ".closebtn", function (e) {
  $(".right-side-setting-panel").removeClass("show");
  $(".top-side-setting-panel").removeClass("show");
});
/* Define Area Assign Button Action Event  */
$(document).on("click", ".assignbtn", function (e) {
  if (selectedRoom) {
    let code = $(document).find("#codeText").val();
    let areadetail = areaDetailLists.find((value) => value.code === code);
    selectedRoom.code = code;
    selectedRoom.name = $(document).find("#descriptionText").val();
    selectedRoom.factor = $(document).find("#factorText").val();
    selectedRoom.roomType = $(document).find("#typeText").val();
    selectedRoom.baseColor = areadetail.color;
    selectedRoom.floorplan.dispatchEvent({
      type: EVENT_ROOM_METADATA_CHANGED,
      item: selectedRoom,
      value: selectedRoom.code,
    });
    roomSettingPanel.classList.remove("show");
  }
  e.preventDefault();
});
/* Define Area Edit Button Action Event  */
$(document).on("click", ".editbtnaction", function (e) {
  $(".editbtns").hide();
  $(".assignbtn").hide();
  $(".updatebtn").show();
  $(".areatextbox").removeAttr("disabled");
  e.preventDefault();
});

/* Define Area Delete Button Action Event  */
$(document).on("click", ".deletebtnaction", function (e) {
  let id = $("#updateAreaId").val();
  let areaTitle = $("#areaTitle").html();
  Swal.fire({
    title: "Delete " + areaTitle + " ?",
    text: "Deleting the preset from this list will remove the preset for all users. Do you really want to remove it?",
    showCancelButton: true,
    confirmButtonColor: "#000000",
    cancelButtonColor: "#fff",
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    showClass: {
      popup: "animate__animated " + alertAnimationName,
    },
  }).then((result) => {
    if (result.isConfirmed) {
      $.ajax({
        type: "GET",
        url: baseUrl + "delete-area-details/" + id,
        data: {},
        dataType: "json",
        success: function (resultData) {
          if (resultData.status) {
            loadAreaData();
            roomSettingPanel.classList.remove("show");
          } else {
            $(".code_error").html(resultData.message);
          }
        },
      });
    }
  });
  e.preventDefault();
});
/* Custom Label Add Custom Text  */
$(document).on("input change", "#labelTextInput", function (e) {
  let text = $(this).val();
  floorplanningHelper.labelText = text;
});
/* Custom Label font Size Input Change  */
$(document).on("change", "#fontSizeInput", function (e) {
  let text = $(this).val();
  floorplanningHelper.labelFontSize = text;
});
/* Custom Label font Size Input Change  */
$(document).on("change", "#fontSizeInputUniversal", function (e) {
  let size = parseInt($(this).val());
  // floorplanningHelper.labelFontSize = text;
  configurationHelper.fontSize = size;
  setFontSize(size);
});
/* Custom Label font Color Change  */
$(document).on("click", ".fontColorInput", function (e) {
  let text = $('input[name="color"]:checked').val();
  floorplanningHelper.labelColor = text;
});

/* Grid Size Checkbox Event  */
$(document).on("click", ".gridSizeInput", function (e) {
  let text = $('input[name="size"]:checked').val();
  configurationHelper.gridSize = parseFloat(text);
});

/* Rotate icons to Scale Drag Event  */
$(document).on("input change", "#iconScaleSlider", function () {
  let value = parseFloat($(this).val());
  floorplanningHelper.iconScale = value;
  $("#iconScaleSlider_text").val(value);
});

/* Rotate icons to Slider Drag Event  */
$(document).on("input change", "#iconRotateSlider", function () {
  let value = parseFloat($(this).val());
  floorplanningHelper.iconRotation = value;
  $("#iconRotateSlider_text").val(value);
});

/* Add icons to Canvas  */
$(document).on("click", ".iconlistul li", function (e) {
  let url = $(this).data("url");
  let name = $(this).data("name");
  addIcon(url, name);
  e.preventDefault();
});

/* Rotate Event Action as icons and Custom Labels  */
$(document).on("click", ".rotateiconul li", function (e) {
  let type = $(this).data("type");
  let id = $(this).data("id");
  let rotation = 0;
  switch (id) {
    case "icon":
      if (selectedIcon) {
        rotation = selectedIcon.icon.rotation;
        if (type == "left") {
          floorplanningHelper.iconRotation = rotation - 45;
        } else {
          floorplanningHelper.iconRotation = rotation + 45;
        }
      }
      break;
    case "label":
      if (selectedLabel) {
        rotation = selectedLabel.label.rotation;
        if (type == "left") {
          floorplanningHelper.labelRotation = rotation - 45;
        } else {
          floorplanningHelper.labelRotation = rotation + 45;
        }
      }
      break;
  }
  e.preventDefault();
});

/* Define area Popup Tab as Preset and New  */
$(document).on("click", ".tab-ul li", function (e) {
  let type = $(this).data("type");
  $(".tab-ul li").removeClass("active");
  $(this).addClass("active");
  switch (type) {
    case "preset":
      $("#presetAreaDefine").show();
      $("#newAreaDefine").hide();
      break;
    case "new":
      $("#presetAreaDefine").hide();
      $("#newAreaDefine").show();
      break;
  }
  e.preventDefault();
});

/* Close Button Action Event */
$(document).on("click", ".cancelbtn", function (e) {
  $(".right-side-setting-panel").removeClass("show");
  $(".top-side-setting-panel").removeClass("show");
});

/* Define Area Insert Button Action Event */
$(document).on("click", ".insertbtn", function (e) {
  let code = $("#codeTextN").val();
  let description = $("#descriptionTextN").val();
  let factor = $("#factorTextN").val();
  let type = $("#typeTextN").val();
  $(".error_text").html("");
  if (code != "") {
    if (description != "") {
      if (factor != "") {
        if (type != "") {
          if (factor.match(/^\d+.?\d*$/)) {
            $.ajax({
              type: "POST",
              url: baseUrl + "insert-area-detail",
              data: {
                code,
                short_description: description,
                factor,
                type,
              },
              dataType: "json",
              success: function (resultData) {
                if (resultData.status) {
                  loadAreaData();
                  if (selectedRoom) {
                    let areadetail = areaTypeLists.find(
                      (value) => value.id === parseInt(type),
                    );
                    selectedRoom.code = code;
                    selectedRoom.name = description;
                    selectedRoom.factor = factor;
                    selectedRoom.roomType = areadetail.type;
                    selectedRoom.baseColor = areadetail.color;
                    selectedRoom.floorplan.dispatchEvent({
                      type: EVENT_ROOM_METADATA_CHANGED,
                      item: selectedRoom,
                      value: selectedRoom.code,
                    });
                    roomSettingPanel.classList.remove("show");
                  }
                } else {
                  $(".code_error").html(resultData.message);
                }
              },
            });
          } else {
            $(".factor_error").html("Only Allowed Numbers");
          }
        } else {
          $(".type_error").html("Please Enter type");
        }
      } else {
        $(".factor_error").html("Please Enter factor");
      }
    } else {
      $(".description_error").html("Please Enter description");
    }
  } else {
    $(".code_error").html("Please Enter code");
  }
  e.preventDefault();
});

/* Define Area Update Button Action Event */
$(document).on("click", ".updatebtn", function (e) {
  let code = $("#codeText").val();
  let description = $("#descriptionText").val();
  let factor = $("#factorText").val();
  let type = $("#typeText").val();
  let id = $("#updateAreaId").val();
  $(".error_text").html("");
  if (code != "") {
    if (description != "") {
      if (factor != "") {
        if (type != "") {
          if (factor.match(/^\d+.?\d*$/)) {
            let areadetail = areaTypeLists.find((value) => value.type === type);
            $.ajax({
              type: "POST",
              url: baseUrl + "update-area-detail",
              data: {
                code,
                short_description: description,
                factor,
                type: areadetail.id,
                id,
              },
              dataType: "json",
              success: function (resultData) {
                if (resultData.status) {
                  loadAreaData();

                  if (selectedRoom) {
                    // let areadetail = areaTypeLists.find(value => value.id === parseInt(type));
                    selectedRoom.code = code;
                    selectedRoom.name = description;
                    selectedRoom.factor = factor;
                    selectedRoom.roomType = areadetail.type;
                    selectedRoom.baseColor = areadetail.color;
                    selectedRoom.floorplan.dispatchEvent({
                      type: EVENT_ROOM_METADATA_CHANGED,
                      item: selectedRoom,
                      value: selectedRoom.code,
                    });
                    roomSettingPanel.classList.remove("show");
                  }
                } else {
                  $(".code_errorE").html(resultData.message);
                }
              },
            });
          } else {
            $(".factor_errorE").html("Only Allowed Numbers");
          }
        } else {
          $(".type_errorE").html("Please Enter type");
        }
      } else {
        $(".factor_errorE").html("Please Enter factor");
      }
    } else {
      $(".description_errorE").html("Please Enter description");
    }
  } else {
    $(".code_errorE").html("Please Enter code");
  }
  e.preventDefault();
});

$(document).keydown(function (e) {
  /* Delete Key Press */
  if (e.keyCode === 46) {
    Swal.fire({
      title: "Are you sure you want to delete this item ?",
      text: "",
      showCancelButton: true,
      confirmButtonColor: "#10ac84",
      cancelButtonColor: "#fff",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showClass: {
        popup: "animate__animated " + alertAnimationName,
      },
    }).then((result) => {
      if (result.isConfirmed) {
        floorplanningHelper.deleteCurrentItem();
        $(".right-side-setting-panel").removeClass("show");
        $(".top-side-setting-panel").removeClass("show");
      }
    });
  }

  /* Undo Key as Ctrl + Z Key Press */
  if (e.keyCode == 90 && e.ctrlKey) {
    floorplanningHelper.undoActions();
    floorPlannerViewer.setLastAction();
    $(".right-side-setting-panel").removeClass("show");
    $(".top-side-setting-panel").removeClass("show");
  }

  /* Take Screenshot Key testing */
  // if(e.keyCode == 80 ){
  //     saveScreenShot();
  // }
});

let isDirty = false;

// Mark page as modified when user interacts
document.addEventListener("mousedown", function () {
  isDirty = true;
});

document.addEventListener("keydown", function () {
  isDirty = true;
});

window.addEventListener("beforeunload", function (event) {
  if (isDirty) {
    event.preventDefault();
    event.returnValue = "";
  }
});
